import { sizeMapper } from "src/styles";
import styled, { css } from "styled-components";

export const ProgressBarContainer = styled.div<{
  margin?: string;
  withBorder?: boolean;
}>`
  width: 100%;
  margin: ${(props) => sizeMapper(props.margin, "no")};
  border-radius: 0.375rem;
  background-color: ${(props) => props.theme.gray};
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  overflow: hidden;

  ${(props) =>
    props.withBorder &&
    css`
      border: 1px solid ${(props) => props.theme.brandPrimary};
    `};
`;

export const ProgressBarDiv = styled.div<{ progress: number }>`
  background-color: ${(props) => props.theme.brandPrimary};
  width: ${(props) => `${props.progress}%`};
  transition: width 200ms;
  height: 0.563rem;
`;
